"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18n_1 = require("@app/util/i18n");
const _ui_1 = require("@ui");
const react_1 = __importStar(require("react"));
const util_1 = require("@app/util");
const moment_1 = __importDefault(require("moment"));
const PlanningInProgress = ({ planCreated, allocatedTime, }) => {
    const [computationPercentage, setComputationPercentage] = (0, react_1.useState)(-1);
    (0, react_1.useEffect)(() => {
        // Update the computation percentage every 2 seconds
        const intervalId = setInterval(() => {
            const startTime = (0, moment_1.default)(planCreated);
            const now = (0, moment_1.default)();
            const duration = moment_1.default.duration(now.diff(startTime));
            const totalDuration = allocatedTime;
            const newPercentage = (0, util_1.isValue)(totalDuration)
                ? Math.min(100, (duration.asMilliseconds() / totalDuration) * 100)
                : 0;
            setComputationPercentage(newPercentage);
        }, 2000);
        // Clear the interval on component unmount
        return () => clearInterval(intervalId);
    }, [allocatedTime]);
    return (react_1.default.createElement("div", { style: { margin: 'auto', height: '100%', position: 'relative' } },
        react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_16, type: _ui_1.Spacing.TYPES.BOTH },
            react_1.default.createElement(_ui_1.Flex, { direction: _ui_1.Flex.DIRECTION.COLUMN, align: _ui_1.Flex.POSITION.CENTER },
                computationPercentage !== -1 && (react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.HEADLINE2 }, (0, i18n_1.t)('RUN_PLANNING_TITLE'))),
                react_1.default.createElement("div", { style: { minHeight: '16rem' } },
                    react_1.default.createElement(_ui_1.Loader, { position: _ui_1.Loader.POSITIONS.STATIC, text: computationPercentage !== -1
                            ? Math.round(computationPercentage).toString() + '%'
                            : ' ', size: _ui_1.Loader.SIZES.LARGE }))))));
};
exports.default = PlanningInProgress;
